const LABELS: Record<string, string> = {
  inside: 'Inside delivery',
  tailgate: 'Tailgate',
  residential: 'Residential',
  dangerousGoods: 'Dangerous goods',
};

/**
 * Accessorial (AVS) Yes/No toggles. Generic over a record of boolean flags so
 * pickup (incl. dangerous goods) and delivery (no DG) can share it.
 */
export function AvsToggles<F extends string>({
  values,
  fields,
  onChange,
}: {
  values: Record<F, boolean>;
  fields: F[];
  onChange: (patch: Partial<Record<F, boolean>>) => void;
}) {
  return (
    <fieldset className="rounded-button border border-brand-border p-3">
      <legend className="px-1 text-sm font-semibold text-brand-muted">Accessorials</legend>
      <div className="grid grid-cols-2 gap-2">
        {fields.map((f) => (
          <label key={f} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              className="h-5 w-5"
              checked={values[f]}
              onChange={(e) => onChange({ [f]: e.target.checked } as Partial<Record<F, boolean>>)}
            />
            {LABELS[f] ?? f}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
